module.exports = __webpack_public_path__ + "static/img/12.a398ea3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/4/sp/12.png
// module id = Sgrs
// module chunks = 0